import { Table } from "@heroui/react";
import { Skeleton } from "@heroui/react";

const range = (n) => Array.from({ length: n }, (_, i) => i);

const SkeletonTable = ({ rows = 8, cols = 10, ariaLabel = "Loading table", headerSkeleton = true }) => {
  return (
    <Table.Root className="p-0 border rounded-lg">
      <Table className="p-0">
        <Table.ScrollContainer>
          <Table.Content aria-label={ariaLabel}>
            <Table.Header className={'bg-surface'}>
              {range(cols).map((i) => (
                <Table.Column key={`h-${i}`}>
                  {headerSkeleton ? <Skeleton className="h-7 w-24 rounded-md" /> : ""}
                </Table.Column>
              ))}
            </Table.Header>

            <Table.Body>
              {range(rows).map((r) => (
                <Table.Row key={`r-${r}`}>
                  {range(cols).map((c) => (
                    <Table.Cell key={`c-${r}-${c}`} className={'rounded-none'}>
                      <Skeleton className="h-5 w-full max-w-[220px] rounded-md" />
                    </Table.Cell>
                  ))}
                </Table.Row>
              ))}
            </Table.Body>
          </Table.Content>
        </Table.ScrollContainer>
      </Table>
    </Table.Root>
  );
};

export default SkeletonTable;